;(function($){
'use strict';
/* ==========================================================================
 *
 * タブユーザーインターフェースクラス
 *
 * global namespace: MY_PROJECT
 *
========================================================================== */
/* name space init
-------------------------------------*/
window.MY_PROJECT = window.MY_PROJECT || {};

/* constructor
---------------------------------------------- */
function contextBan(){
	let _ = this;

	// オプション
	_.config = {
		exec: false,
		// 下記配列に指定したセレクタを右クリック不可にする
		banSelector: [
			'img',
		],
	};

	_.init();
};

/* ----------------------------------------------
 * init
 * @ :
 * return :
---------------------------------------------- */
contextBan.prototype.init = function(){
	let _ = this;

	_.start();
};

/* start
 * @string:
 * return array = hash strings array
---------------------------------------------- */
contextBan.prototype.start = function($group){
	let _ = this;

	$(document).on('ready',function(){
		$.each(_.config.banSelector,function(i){
			$(this).on('contextmenu', function(e){
				return false;
			});
		});
	});
};

/* ==========================================================================
 * プロジェクトインスタンス生成
========================================================================== */
window.MY_PROJECT.contextBan = $.extend( true ,new contextBan(), window.MY_PROJECT.contextBan );

})(jQuery);
